import React from 'react';
import {
  type Player,
  PLAYER_DISCONNECTED_EVENT,
  PLAYER_JOINED_EVENT,
} from '@mentimeter/quiz-types';
import { useSubscribe } from './use-subscribe';

export const useSubscribePlayers = () => {
  const [players, setPlayers] = React.useState<Player[]>([]);
  const [disconnectedPlayers, setDisconnectedPlayers] = React.useState<
    string[]
  >([]);

  useSubscribe({
    event: PLAYER_JOINED_EVENT,
    callback: React.useCallback((player) => {
      // Player rejoined, so remove from disconnectedPlayers
      setDisconnectedPlayers((prev) => {
        return prev.filter((p) => p !== player.identifier);
      });
      // Add to players list, unless they are already there
      setPlayers((prev) => {
        if (prev.some((p) => p.identifier === player.identifier)) return prev;
        return [...prev, player];
      });
    }, []),
  });

  useSubscribe({
    event: PLAYER_DISCONNECTED_EVENT,
    callback: React.useCallback(({ identifier }) => {
      setDisconnectedPlayers((prev) => {
        if (prev.includes(identifier)) return prev;
        return [...prev, identifier];
      });
    }, []),
  });

  const resetPlayers = React.useCallback(() => {
    setPlayers([]);
    setDisconnectedPlayers([]);
  }, []);

  const connectedPlayers = React.useMemo(
    () =>
      players.filter(
        ({ identifier }) => !disconnectedPlayers.includes(identifier),
      ),
    [disconnectedPlayers, players],
  );

  return {
    connectedPlayers,
    totalPlayersCount: players.length,
    resetPlayers,
  };
};
